import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
	Icon,
	Loader,
	Popup,
	Header
} from 'semantic-ui-react';

import { useUIState } from '../../../contexts/UIContext';

const HelpModal = ( {
	id,
	triggerOverride,
	triggerPosition = 'right',
	triggerSize,
	triggerStyles
} ) => {
	const { docs, showHelp } = useUIState();

	const doc = useMemo( () => docs.find( doc => doc.id === id ), [ docs, id ] );

	if ( !showHelp ) {
		return null;
	}

	return (
		<Popup
			content={ !doc
				? <div style={ { minWidth: '32px', minHeight: '32px' } }>
					<Loader active/>
				</div>
				: <>
					<Header>{ doc.label }</Header>
					<p>{ doc.text }</p>
					<p style={ { textAlign: 'right' } }>
						<a
							href={ doc.docURL }
							target="blank"
							rel="noopener noreferrer"
						>
							<Icon
								circular
								color="black"
								link
								name="book"/>
						</a>
						{ doc.videoURL
							? <>
								&nbsp;&nbsp;
								<a
									href={ doc.videoURL }
									target="blank"
									rel="noopener noreferrer"
								>
									<Icon
										circular
										color="black"
										link
										name="video"
									/>
								</a>
							</>
							: null
						}
					</p>
				</>
			}
			hoverable
			pointing
			trigger={
				triggerOverride
					? triggerOverride
					: <Icon
						color="brown"
						name="question circle"
						style={ {
							cursor: 'pointer',
							fontSize: triggerSize === 'large'
								? '1.5rem'
								: triggerSize === 'small'
									? '1rem'
									: triggerSize === 'tiny'
										? '0.75rem'
										: '1.25rem',
							lineHeight: 1,
							margin: triggerPosition === 'right'
								? '0 0 0 0.35rem'
								: '0 0.35rem 0 0',
							verticalAlign: 'initial',
							...triggerStyles
						} }
					/>
			}
		/>
	);
};

HelpModal.propTypes = {
	id: PropTypes.number.isRequired,
	triggerOverride: PropTypes.node,
	triggerPosition: PropTypes.oneOf( [ 'left', 'right' ] ),
	triggerSize: PropTypes.oneOf( [ 'large', 'small', 'tiny' ] ),
	triggerStyles: PropTypes.object
};

export default HelpModal;
